import styled, { css } from 'styled-components'
import { desktopBreakpoint, tabletBreakpoint } from 'react-components'

export const Container = styled.section(
    ({ theme }) => css`
        padding: ${theme.spacing.medium} ${theme.spacing.large};
        margin-top: ${theme.spacing.xLarge};
        position: relative;

        @media only screen and (min-width: ${desktopBreakpoint.min}px) {
            padding: 1rem 2.75rem;
            max-width: 87.5rem;
            margin: ${theme.spacing.Large} auto 0;
        }
    `,
)

export const ContentWrapper = styled.div(
    ({ theme }) => css`
        padding: 0;

        @media only screen and (min-width: ${desktopBreakpoint.min}px) {
            padding-bottom: ${theme.spacing.medium};
        }
    `,
)

export const SectionTitle = styled.h2(
    ({ theme }) => css`
        margin: 0;
        font-weight: ${theme.typography.font.weight.normal};
        font-size: ${theme.typography.font.size.large};
        line-height: 1.75rem;
        color: ${theme.colors.tfwBlack99};
        letter-spacing: 0.02rem;

        @media only screen and (min-width: ${tabletBreakpoint.min}px) {
            font-size: 1.75rem;
            line-height: 2.625rem;
            letter-spacing: 0.025rem;
        }

        @media only screen and (min-width: ${desktopBreakpoint.min}px) {
            font-size: 1.5625rem;
            line-height: 1.875rem;
            letter-spacing: 0.02rem;
        }
    `,
)

export const HeaderSection = styled.div(
    ({ theme }) => css`
        margin-bottom: ${theme.spacing.large};
    `,
)

export const HighlightedReviewerName = styled.span`
    color: #006ad4;
`

export const ReviewerSection = styled.div(
    ({ theme }) => css`
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: ${theme.spacing.medium};

        @media only screen and (min-width: ${tabletBreakpoint.min}px) {
            flex-direction: row;
            align-items: flex-start;
        }
    `,
)

export const ReviewerImageWrapper = styled.div`
    width: 8rem;
    height: 8rem;
    border-radius: 50%;
    overflow: hidden;
    flex-shrink: 0;

    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        width: 10rem;
        height: 10rem;
    }

    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        width: 8rem;
        height: 8rem;
    }
`

export const ReviewerInfo = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
    text-align: center;

    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        text-align: left;
    }
`

export const ReviewerName = styled.h3(
    ({ theme }) => css`
        margin: 0;
        font-weight: ${theme.typography.font.weight.normal};
        font-size: ${theme.typography.font.size.large};
        line-height: 1.75rem;
        color: ${theme.colors.tfwBlack99};
        letter-spacing: -0.021875rem;

        @media only screen and (min-width: ${tabletBreakpoint.min}px) {
            font-size: 1.75rem;
            line-height: 2.625rem;
            letter-spacing: -0.0625rem;
        }

        @media only screen and (min-width: ${desktopBreakpoint.min}px) {
            font-size: 1.5625rem;
            line-height: 1.875rem;
        }
    `,
)
export const ReviewerDescription = styled.div(
    ({ theme }) => css`
        font-weight: ${theme.typography.font.weight.normal};
        font-size: ${theme.typography.font.size.small};
        line-height: 1.6;
        color: #5f5f5f !important;
        flex: 1;
        text-align: left;

        @media only screen and (min-width: ${tabletBreakpoint.min}px) {
            font-size: ${theme.typography.font.size.medium};
        }
    `,
)

export const LastUpdated = styled.p(
    ({ theme }) => css`
        padding-top: 0.25rem;
        font-weight: ${theme.typography.font.weight.normal};
        font-size: ${theme.typography.font.size.small};
        line-height: 1.25rem;
        color: #5f5f5f;

        @media only screen and (min-width: ${tabletBreakpoint.min}px) {
            font-size: ${theme.typography.font.size.medium};
            line-height: 1.5rem;
        }
    `,
)
